import { render, staticRenderFns } from "./Chargepersonal.vue?vue&type=template&id=c4e626b8"
import script from "./Chargepersonal.vue?vue&type=script&lang=js"
export * from "./Chargepersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports